import React from 'react';
import { MdWarning } from 'react-icons/md';

function CloseRepProfileModal({ submitting, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <MdWarning className="text-2xl text-red-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Close Representative Profile?</h3>
            <p className="text-sm text-gray-600">This action cannot be undone.</p>
          </div>
        </div>

        <p className="text-gray-600 mb-6">
          Closing your representative profile will remove you from search results and hide your public poll responses.
          You can create a new profile later if needed.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
          >
            {submitting ? 'Closing...' : 'Close Profile'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CloseRepProfileModal;
